import React, { useState } from 'react';
import Button from 'shared/components/UC/Button';
import styles from './SingaporeDeclarationModal.module.css';

interface Props {
  accepted: boolean;
  onAccept: (value: boolean) => void;
  onClose: () => void;
}

const SingaporeDeclarationModal: React.FC<Props> = ({ accepted, onAccept, onClose }) => {
  const [checked, setChecked] = useState(accepted);

  const handleConfirm = () => {
    onAccept(checked);
    onClose();
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>
            Declaración de Singapur sobre Integridad en la Investigación
          </h2>
          <button
            type="button"
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Cerrar"
          >
            <i className="uc-icon">close</i>
          </button>
        </div>

        {/* PDF viewer */}
        <div className={styles.pdfWrapper}>
          <iframe
            src="/templates/DECLARACI%C3%93N-SINGAPUR.pdf"
            className={styles.pdfFrame}
            title="Declaración de Singapur sobre Integridad en la Investigación"
          />
        </div>

        {/* Footer: checkbox + botón */}
        <div className={styles.footer}>
          <label className={`${styles.checkboxLabel} ${accepted ? styles.checkboxLabelLocked : ''}`}>
            <input
              type="checkbox"
              className={styles.checkbox}
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
              disabled={accepted}
            />
            <span className={styles.checkboxText}>
              He leído y acepto la{' '}
              <strong>Declaración de Singapur sobre Integridad en la Investigación</strong>.
              Me comprometo a conducir mi investigación de acuerdo con sus principios de
              honestidad, responsabilidad, cortesía profesional y buena gestión.
            </span>
          </label>
          <Button
            variant="primary"
            onClick={handleConfirm}
            disabled={!checked}
            className={styles.confirmButtonAlign}
          >
            {accepted ? 'Cerrar' : 'Confirmar y cerrar'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SingaporeDeclarationModal;
